module.exports = __webpack_public_path__ + "img/GPB_top10.d56b0ade.png";